import { CaretIcon } from "styles/icons";

export const knowYourRightsMenu = [
  { storyblokId: 71636182, label: "menu_air_passenger_rights" },
  { storyblokId: 71636830, label: "menu_flight_delay_compensation" },
  { storyblokId: 71636192, label: "menu_flight_cancellation_compensation" },
  { storyblokId: 71636184, label: "menu_missed_connection_compensation" },
  { storyblokId: 71636186, label: "menu_overbooking" },
  { storyblokId: 71636188, label: "menu_denied_boarding_compensation" },
  { storyblokId: 71636187, label: "menu_delayed_baggage_compensation" },
  { page: "airlineStrikeCompensation", label: "menu_airline_strike" },
  { page: "airlines", label: "menu_airlines" },
  { page: "airports", label: "menu_airports" },
  { storyblokId: 71636914, label: "menu_coronavirus" },
];

export const topMenu = [
  { label: "menu_know_your_rights", subMenu: knowYourRightsMenu, icon: CaretIcon, dataQA: "top-navbar-kyr" },
  { storyblokId: 61788293, label: "menu_about_us", prefetch: true },
  {
    storyblokId: 168095828,
    label: "menu_airhelp_plus",
    prefetch: true,
    dataQA: "top-navbar-ah-plus",
  },
];

export const productsMenu = [
  { page: "webappNewClaim", label: "check_your_compensation" },
  { storyblokId: 168095828, label: "menu_airhelp_plus", prefetch: true },
  { storyblokId: 64335827, label: "menu_refer_a_friend", prefetch: true },
  { storyblokId: 94128112, label: "menu_score" },
  { storyblokId: 71636194, label: "menu_reviews" },
];

export const companyMenu = [
  { storyblokId: 61788293, label: "menu_about_us", prefetch: true },
  { storyblokId: 56747218, label: "menu_blog", prefetch: true },
  { storyblokId: 62392695, label: "menu_press", prefetch: true },
  { page: "careers", label: "menu_careers" },
  { storyblokId: 86291623, label: "menu_affiliate" },
  { storyblokId: 71112922, label: "menu_legal_partners", prefetch: true },
  { storyblokId: 68898974, label: "menu_partners", prefetch: true },
  { storyblokId: 70480540, label: "menu_for_airlines", prefetch: true, fallback: "en" },
];

export const supportMenu = [
  { storyblokId: 90578664, label: "menu_help" },
  { storyblokId: 52702007, label: "menu_price_list", prefetch: true },
  { storyblokId: 142848538, label: "our_fees", prefetch: true },
];

export const legalMenu = [
  { storyblokId: 43841167, label: "terms_link_title", prefetch: true },
  { storyblokId: 52663019, label: "terms_privacy_link_title", prefetch: true },
  { storyblokId: 44293804, label: "cookies", prefetch: true },
];

export const imprintMenu = [{ storyblokId: 52883090, label: "menu_imprint", prefetch: true }];
